const RenderColumns = (/* primaryKey */) => [
  ["Name", "name"],
  ["City", "city"],
  ["State / Country", ["state", "country"]],
  ["Login Email Id", "email"],
  ["Communication Email Id", "communicationEmail"],
  [
    "Type",
    (user) =>
      Array.isArray(user?.type) ? user.type.join(",") : user?.type || "",
  ],
  ["Status", (user) => (user?.inactive ? "Deactivated" : "Active")],
];

export default RenderColumns;
